import { Link } from 'react-router-dom'

const BRAND_COLOR = '#536C7C'

function LockedPagePlaceholder({ reason, prerequisitePath, prerequisiteLabel }) {
  const color = BRAND_COLOR

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md">
        {/* Lock icon */}
        <div className="mx-auto mb-6">
          <svg className="w-12 h-12 mx-auto" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.2} style={{ opacity: 0.15 }}>
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0110 0v4" />
          </svg>
        </div>

        {/* Reason text */}
        <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
          {reason}
        </h2>

        {/* CTA button */}
        {prerequisitePath && (
          <Link
            to={prerequisitePath}
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-white rounded-md transition-colors"
            style={{ backgroundColor: color }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            {prerequisiteLabel || 'Go to prerequisite'}
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        )}

        {/* Subtext */}
        <p className="text-[13px] text-gray-400 dark:text-gray-500 mt-5" style={{ opacity: 0.6 }}>
          This page will unlock automatically when the required data is available.
        </p>
      </div>
    </div>
  )
}

export default LockedPagePlaceholder
